import connect from 'components/Shared/connect';
import { getCurrentCampaigns } from 'views/ProductlistPage/selectors';
import { Ad } from 'components/Ad';
import { Section } from 'components/Section';
import { RedAd } from 'models/RedAd';
import { rm, NO_ELEMENT } from 'utils';

import styles from './styles.scss';

interface MergedProps {
  campaigns: RedAd[];
}

const hasCampaigns = (campaigns: RedAd[]) => campaigns && campaigns.length;
const CurrentCampaigns = ({ campaigns }: MergedProps) =>
  hasCampaigns(campaigns) ? (
    <Section
      title={rm('current_campaigns_title')}
      className={styles.section}
      titleClassName={styles.title}
    >
      <div className={styles.currentCampaigns}>
        {campaigns.map(campaign => (
          <Ad key={campaign.ticket} ad={campaign} className={styles.campaign} />
        ))}
      </div>
    </Section>
  ) : (
    NO_ELEMENT
  );

export default connect<MergedProps>(({ currentPage }) => ({
  campaigns: getCurrentCampaigns(currentPage)
}))(CurrentCampaigns);
